module.exports = __webpack_public_path__ + "img/modular_settlement_complete_yellow@2x.5bdaea71.png";